import styled from '@emotion/styled';
import Grid from '@react-css/grid';
import { Outlet, useLocation } from 'react-router-dom';
import Card from 'storybookConfig/stories/cells/Card';
import Menu from 'storybookConfig/stories/cells/Menu';

const MenuWrapper = styled(Card)`
  padding: 24px;
  position: sticky;
  top: 24px;
`;

enum SectionSegments {
  Profile = 'profile',
  Locations = 'locations',
  TeamMembers = 'team-members',
  Rules = 'rules',
}

const CompanySettings = () => {
  const { pathname } = useLocation();
  const section = pathname.split('/')[3] as SectionSegments | undefined;

  const selectedSection =
    section && Object.values(SectionSegments).includes(section) ? section : SectionSegments.Profile;

  return (
    <Grid columns="240px 1fr" gap="24px">
      <Grid.Item>
        <MenuWrapper>
          <Menu>
            <Menu.Link
              $iconName="apartment"
              $isActive={selectedSection === SectionSegments.Profile}
              to="/settings/company/profile"
            >
              Profile
            </Menu.Link>

            <Menu.Link
              $iconName="pin_drop"
              $isActive={selectedSection === SectionSegments.Locations}
              to="/settings/company/locations"
            >
              Locations
            </Menu.Link>

            <Menu.Link
              $iconName="group"
              $isActive={selectedSection === SectionSegments.TeamMembers}
              to="/settings/company/team-members"
            >
              Team Members
            </Menu.Link>

            <Menu.Link
              $iconName="admin_panel_settings"
              $isActive={selectedSection === SectionSegments.Rules}
              to="/settings/company/rules"
            >
              Rules
            </Menu.Link>
          </Menu>
        </MenuWrapper>
      </Grid.Item>

      <Card>
        <Outlet />
      </Card>
    </Grid>
  );
};

export default CompanySettings;
